import { render } from "./PagarProveedorModal.vue?vue&type=template&id=c48dc4a4&scoped=true"
import script from "./PagarProveedorModal.vue?vue&type=script&lang=js"
export * from "./PagarProveedorModal.vue?vue&type=script&lang=js"

import "./PagarProveedorModal.vue?vue&type=style&index=0&id=c48dc4a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c48dc4a4"]])

export default __exports__